export const UserCircle = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 4.375C8.08594 4.375 6.5625 5.9375 6.5625 7.8125C6.5625 9.72656 8.08594 11.25 10 11.25C11.875 11.25 13.4375 9.72656 13.4375 7.8125C13.4375 5.9375 11.875 4.375 10 4.375ZM10 9.375C9.10156 9.375 8.4375 8.71094 8.4375 7.8125C8.4375 6.95312 9.10156 6.25 10 6.25C10.8594 6.25 11.5625 6.95312 11.5625 7.8125C11.5625 8.71094 10.8594 9.375 10 9.375ZM10 0C4.45312 0 0 4.49219 0 10C0 15.5469 4.45312 20 10 20C15.5078 20 20 15.5469 20 10C20 4.49219 15.5078 0 10 0ZM10 18.125C8.16406 18.125 6.48438 17.5391 5.11719 16.5234C5.78125 15.1953 7.10938 14.375 8.59375 14.375H11.3672C12.8516 14.375 14.1797 15.2344 14.8438 16.5234C13.4766 17.5391 11.7969 18.125 10 18.125ZM16.25 15.1953C15.1953 13.5547 13.3984 12.5 11.3672 12.5H8.59375C6.5625 12.5 4.76562 13.5547 3.71094 15.1953C2.53906 13.7891 1.875 11.9922 1.875 10C1.875 5.54688 5.50781 1.875 10 1.875C14.4531 1.875 18.125 5.54688 18.125 10C18.125 11.9922 17.4219 13.7891 16.25 15.1953Z"
        fill="black"
      />
    </svg>
  );
};
